/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getFlightTicketApi } from '../../api/flightApi';
import {
  NAVIGATION_ROUTES,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  DATE_MONTH_YEAR_FORMAT,
} from '../../shared/constants/Constants';
import {
  formatTimeString,
  formatDate,
  getNewDate,
  isEmpty,
  getBankDetails,
  isNullOrEmpty,
} from '../../shared/helper-utils/appUtils';
import {
  getObjectFromLS,
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import './FlightTicketPage.scss';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import NumberToWords from '../../shared/components/NumberToWords';
import {
  APP_AGENT_LOGO_URL,
  APP_LOGO_URL,
  APP_USER_PROFILE,
} from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { AIRLINE_NAMES_FOR_CARRIER_CODE } from '../../shared/constants/FlightCarrierNames';

function FlightTicketInvoicePage() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [showFare, setShowFare] = useState(true);
  const [hasTicket, setHasTicket] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const flightInvoiceRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef({});
  const flightSectorsRef = useRef({});
  const taxNodesRef = useRef([]);
  const sectorFareTypesRef = useRef({});
  const sectorFullNameMapRef = useRef({});
  const barCodesRef = useRef({});
  const agentDetailsRef = useRef(null);
  const flightTicketRef = useRef(null);
  const passengerSSRRef = useRef([]);
  const onwardSectorRef = useRef([]);
  const onwardPaxRef = useRef([]);
  const returnSectorRef = useRef([]);
  const returnPaxRef = useRef([]);
  const creditDebitNoteRef = useRef([]);
  const bankDetails = getBankDetails();
  const [imageLoadError, setImageLoadError] = useState(false);

  useEffect(() => {
    const header = document.querySelector('.app-header');
    const footer = document.querySelector('.app-footer');

    if (header) header.style.display = 'none';
    if (footer) footer.style.display = 'none';

    return () => {
      if (header) header.style.display = '';
      if (footer) footer.style.display = '';
    };
  }, []);

  const getPricingLogJourneyType = (fullBreakup) => {
    const getTaxNodes = (breakup) => {
      if (isEmpty(breakup) || isEmpty(breakup.TaxNode)) {
        return [];
      }
      return Array.isArray(breakup.TaxNode)
        ? breakup.TaxNode
        : [breakup.TaxNode];
    };

    const taxNodes = [
      ...getTaxNodes(fullBreakup?.TotalBreakup),
      ...getTaxNodes(fullBreakup?.AdultBreakup),
      ...getTaxNodes(fullBreakup?.ChildBreakup),
      ...getTaxNodes(fullBreakup?.InfantBreakup),
    ];
    const taxNodeJourneyType = taxNodes
      .find((taxNode) => !isEmpty(taxNode?.Jtype))
      ?.Jtype?.toLowerCase();

    if (taxNodeJourneyType === 'return' || taxNodeJourneyType === 'onward') {
      return taxNodeJourneyType;
    }

    const sectorJourneyType = fullBreakup?.Sector?.toLowerCase();
    if (sectorJourneyType === 'return' || sectorJourneyType === 'onward') {
      return sectorJourneyType;
    }

    return '';
  };

  const setFareSummary = (data) => {
    const invoice = data.FullFlightDetails.FlightInvoice;
    const totalPax = invoice.FlightRecord.NumPax;
    let kValue = 0;
    let yqValue = 0;
    let yrValue = 0;
    const { FlightApiPricingLogs } = invoice;
    if (
      FlightApiPricingLogs !== '' &&
      FlightApiPricingLogs !== undefined &&
      FlightApiPricingLogs !== null
    ) {
      const { FlightApiPricingLog } = FlightApiPricingLogs;
      if (
        FlightApiPricingLog !== '' &&
        FlightApiPricingLog !== null &&
        FlightApiPricingLog !== undefined
      ) {
        const list = Array.isArray(FlightApiPricingLog)
          ? FlightApiPricingLog
          : [FlightApiPricingLog];
        list.forEach((item) => {
          if (item.ResponseXml && item?.ResponseXml?.FullBreakup) {
            if (Object.keys(item.ResponseXml?.FullBreakup).length > 0) {
              const kForSector =
                item.ResponseXml.FullBreakup.AdultJn *
                  invoice.FlightRecord.NumAdults +
                item.ResponseXml.FullBreakup.ChildJn *
                  invoice.FlightRecord.NumChildren +
                item.ResponseXml.FullBreakup.InfantJn *
                  invoice.FlightRecord.NumInfants;
              kValue += kForSector;
              yqValue +=
                item.ResponseXml.FullBreakup.AdultYq *
                  invoice.FlightRecord.NumAdults +
                item.ResponseXml.FullBreakup.ChildYq *
                  invoice.FlightRecord.NumChildren +
                item.ResponseXml.FullBreakup.InfantYq *
                  invoice.FlightRecord.NumInfants;
              if (
                !isEmpty(item.ResponseXml?.FullBreakup?.AdultBreakup) &&
                !isEmpty(item.ResponseXml?.FullBreakup?.AdultBreakup?.TaxNode)
              ) {
                const taxList = Array.isArray(
                  item.ResponseXml.FullBreakup.AdultBreakup.TaxNode,
                )
                  ? item.ResponseXml.FullBreakup.AdultBreakup.TaxNode
                  : [item.ResponseXml.FullBreakup.AdultBreakup.TaxNode];
                taxList.forEach((x) => {
                  if (x.TaxName.toLowerCase() === 'yr') {
                    yrValue += x.TaxValue * totalPax;
                  }
                });
              }
            }
          }
        });
      }
    }
    const fareDetailsStr =
      invoice?.CompleteFareDetails?.OWFareDetails?.split('##').map(Number);
    const baseFare = fareDetailsStr[0];
    const pgCharge = invoice.FlightRecord.PgCharges;
    const airlineTaxes = Math.round(
      fareDetailsStr[1] -
        pgCharge -
        kValue -
        yqValue -
        yrValue +
        fareDetailsStr[17],
    );
    // const airlineTaxes = Math.round(fareDetailsStr[1]);
    const ssr = invoice.FlightRecord.SSRAmount;
    const airlineTotal = Math.round(
      baseFare + airlineTaxes + kValue + yqValue + yrValue + ssr,
    );
    const serviceCharges = fareDetailsStr[8];
    const commmission = fareDetailsStr[5];
    const tds = fareDetailsStr[4];
    const transactionFee = fareDetailsStr[6];
    fareSummaryRef.current = {
      basefare: baseFare,
      airlinetaxes: airlineTaxes,
      addons: ssr,
      airlinetotal: airlineTotal,
      servicecharges: serviceCharges,
      Commmission: commmission,
      Tds: tds,
      transactionFee,
      kvalue: kValue,
      yqvalue: yqValue,
      yrvalue: yrValue,
    };
    const gst_number = agentDetailsRef.current.Gst_number;
    const serviceTax = fareDetailsStr[3];
    let sgst = 0;
    let cgst = 0;
    let igst = 0;
    const client_gstnumber = getValueFromAppConfig('GSTIN');

    let isIntraState = false;

    if (
      client_gstnumber &&
      typeof client_gstnumber === 'string' &&
      client_gstnumber.length >= 2
    ) {
      isIntraState =
        gst_number?.substring(0, 2) === client_gstnumber.substring(0, 2);
    } else if (agentDetailsRef.current?.State === 'DL') {
      isIntraState = true;
    }

    if (isIntraState) {
      sgst = serviceTax / 2;
      cgst = serviceTax / 2;
      igst = 0;
    } else {
      sgst = 0;
      cgst = 0;
      igst = serviceTax;
    }

    fareSummaryRef.current.Sgst = sgst;
    fareSummaryRef.current.Cgst = cgst;
    fareSummaryRef.current.Igst = igst;
    fareSummaryRef.current.Servicetax = serviceTax;
    const totalAmount =
      airlineTotal +
      serviceCharges +
      sgst +
      cgst +
      igst -
      commmission +
      tds +
      transactionFee;
    fareSummaryRef.current.totalamount = totalAmount;
  };

  const setRoundtripFareSummary = (data) => {
    const invoice = data.FullFlightDetails.FlightInvoice;
    const hasDebitNote = creditDebitNoteRef.current.some(
      (note) => note.TxType === 'DEBITNOTE',
    );
    const hasCreditNote = creditDebitNoteRef.current.some(
      (note) => note.TxType === 'CREDITNOTE',
    );
    let debitCreditNoteSign = 0;
    if (hasDebitNote) {
      debitCreditNoteSign = -1;
    } else if (hasCreditNote) {
      debitCreditNoteSign = 1;
    }
    let onwardKValue = 0;
    let returnKValue = 0;
    let onwardYrValue = 0;
    let returnYrValue = 0;
    let onwardYqValue = 0;
    let returnYqValue = 0;
    const { FlightApiPricingLogs } = invoice;
    if (
      FlightApiPricingLogs !== '' &&
      FlightApiPricingLogs !== undefined &&
      FlightApiPricingLogs !== null
    ) {
      const { FlightApiPricingLog } = FlightApiPricingLogs;
      if (
        FlightApiPricingLog !== '' &&
        FlightApiPricingLog !== null &&
        FlightApiPricingLog !== undefined
      ) {
        const list = Array.isArray(FlightApiPricingLog)
          ? FlightApiPricingLog
          : [FlightApiPricingLog];
        list.forEach((item) => {
          if (item.ResponseXml && item?.ResponseXml?.FullBreakup) {
            const { FullBreakup } = item.ResponseXml;
            if (Object.keys(FullBreakup).length > 0) {
              if (getPricingLogJourneyType(FullBreakup) === 'return') {
                const kForSector =
                  (FullBreakup.AdultJn || 0) +
                  (FullBreakup.ChildJn || 0) +
                  (FullBreakup.InfantJn || 0);
                returnKValue += kForSector;
                returnYqValue +=
                  (FullBreakup.AdultYq || 0) +
                  (FullBreakup.ChildYq || 0) +
                  (FullBreakup.InfantYq || 0);
                if (
                  !isEmpty(FullBreakup?.AdultBreakup) &&
                  !isEmpty(FullBreakup?.AdultBreakup?.TaxNode)
                ) {
                  const taxList = Array.isArray(
                    FullBreakup.AdultBreakup.TaxNode,
                  )
                    ? FullBreakup.AdultBreakup.TaxNode
                    : [FullBreakup.AdultBreakup.TaxNode];
                  taxList.forEach((x) => {
                    if (x.TaxName.toLowerCase() === 'yr') {
                      returnYrValue += x.TaxValue;
                    }
                  });
                }
              } else {
                const kForSector =
                  (FullBreakup.AdultJn || 0) +
                  (FullBreakup.ChildJn || 0) +
                  (FullBreakup.InfantJn || 0);
                onwardKValue += kForSector;
                onwardYqValue +=
                  (FullBreakup.AdultYq || 0) +
                  (FullBreakup.ChildYq || 0) +
                  (FullBreakup.InfantYq || 0);
                if (
                  !isEmpty(FullBreakup?.AdultBreakup) &&
                  !isEmpty(FullBreakup?.AdultBreakup?.TaxNode)
                ) {
                  const taxList = Array.isArray(
                    FullBreakup.AdultBreakup.TaxNode,
                  )
                    ? FullBreakup.AdultBreakup.TaxNode
                    : [FullBreakup.AdultBreakup.TaxNode];
                  taxList.forEach((x) => {
                    if (x.TaxName.toLowerCase() === 'yr') {
                      onwardYrValue += x.TaxValue;
                    }
                  });
                }
              }
            }
          }
        });
      }
    }

    const onwardfareDetailsStr = invoice?.CompleteFareDetails?.OWFareDetails
      ? invoice?.CompleteFareDetails?.OWFareDetails?.split('##').map(Number)
      : invoice.FlightRecord?.FareDetails?.split('##').map(Number) || [];

    if (onwardfareDetailsStr && onwardfareDetailsStr.length > 0) {
      const baseFare = onwardfareDetailsStr[0] || 0;
      const pgCharge = invoice.FlightRecord.PgCharges || 0;
      const airlineTaxes = Math.round(
        (onwardfareDetailsStr[1] || 0) -
          pgCharge -
          onwardKValue -
          onwardYqValue -
          onwardYrValue,
      );
      const ssr = onwardfareDetailsStr[14] || 0;
      const airlineTotal = Math.round(
        baseFare +
          airlineTaxes +
          onwardKValue +
          ssr +
          onwardYqValue +
          onwardYrValue,
      );
      const serviceCharges = onwardfareDetailsStr[8] || 0;
      const commmission = onwardfareDetailsStr[5] || 0;
      const tds = onwardfareDetailsStr[4] || 0;
      const onwardDebitCreditNote =
        onwardfareDetailsStr[onwardfareDetailsStr.length - 1] || 0;
      const onwardtransactionFee = onwardfareDetailsStr[18] || 0;
      fareSummaryRef.current = {
        onwardbasefare: baseFare,
        onwardairlinetaxes: airlineTaxes,
        onwardaddons: ssr,
        onwardairlinetotal: airlineTotal,
        onwardservicecharges: serviceCharges,
        onwardCommmission: commmission,
        onwardTds: tds,
        onwardDebitCreditNote,
        onwardtransactionFee,
        onwardkvalue: onwardKValue,
        onwardyqvalue: onwardYqValue,
        onwardyrvalue: onwardYrValue,
      };
      const gst_number = agentDetailsRef.current.Gst_number;
      const serviceTax = onwardfareDetailsStr[3] || 0;
      let sgst = 0;
      let cgst = 0;
      let igst = 0;
      if (gst_number && gst_number.substring(0, 2) === '24') {
        sgst = serviceTax / 2;
        cgst = serviceTax / 2;
        igst = 0;
      } else {
        sgst = 0;
        cgst = 0;
        igst = serviceTax;
      }
      fareSummaryRef.current.onwardSgst = sgst;
      fareSummaryRef.current.onwardCgst = cgst;
      fareSummaryRef.current.onwardIgst = igst;
      const totalAmount =
        airlineTotal +
        serviceCharges +
        sgst +
        cgst +
        igst -
        commmission +
        tds +
        onwardtransactionFee +
        debitCreditNoteSign * onwardDebitCreditNote;
      fareSummaryRef.current.onwardtotalamount = totalAmount;
    } else {
      fareSummaryRef.current = {
        onwardbasefare: 0,
        onwardairlinetaxes: 0,
        onwardaddons: 0,
        onwardairlinetotal: 0,
        onwardservicecharges: 0,
        onwardCommmission: 0,
        onwardTds: 0,
        onwardDebitCreditNote: 0,
        onwardtransactionFee: 0,
        onwardkvalue: 0,
        onwardyqvalue: 0,
        onwardyrvalue: 0,
        onwardSgst: 0,
        onwardCgst: 0,
        onwardIgst: 0,
        onwardtotalamount: 0,
      };
    }

    const returnfareDetailsStr = invoice?.CompleteFareDetails?.RTFareDetails
      ? invoice?.CompleteFareDetails?.RTFareDetails?.split('##').map(Number)
      : [];

    if (returnfareDetailsStr && returnfareDetailsStr.length > 0) {
      const baseFare = returnfareDetailsStr[0] || 0;
      const pgCharge = invoice.FlightRecord.PgCharges || 0;
      const airlineTaxes = Math.round(
        (returnfareDetailsStr[1] || 0) -
          pgCharge -
          returnKValue -
          returnYqValue -
          returnYrValue,
      );
      const ssr = returnfareDetailsStr[14] || 0;
      const airlineTotal = Math.round(
        baseFare +
          airlineTaxes +
          returnKValue +
          returnYqValue +
          returnYrValue +
          ssr,
      );
      const serviceCharges = returnfareDetailsStr[8] || 0;
      const commmission = returnfareDetailsStr[5] || 0;
      const tds = returnfareDetailsStr[4] || 0;
      const returnDebitCreditNote =
        returnfareDetailsStr[returnfareDetailsStr.length - 1] || 0;
      const returntransactionFee = returnfareDetailsStr[18] || 0;
      fareSummaryRef.current.returnbasefare = baseFare;
      fareSummaryRef.current.returnairlinetaxes = airlineTaxes;
      fareSummaryRef.current.returnaddons = ssr;
      fareSummaryRef.current.returnairlinetotal = airlineTotal;
      fareSummaryRef.current.returnservicecharges = serviceCharges;
      fareSummaryRef.current.returnCommmission = commmission;
      fareSummaryRef.current.returnTds = tds;
      fareSummaryRef.current.returnDebitCreditNote = returnDebitCreditNote;
      fareSummaryRef.current.returntransactionFee = returntransactionFee;
      fareSummaryRef.current.returnkvalue = returnKValue;
      fareSummaryRef.current.returnyqvalue = returnYqValue;
      fareSummaryRef.current.returnyrvalue = returnYrValue;
      const gst_number = agentDetailsRef.current.Gst_number;
      const serviceTax = returnfareDetailsStr[3] || 0;
      let sgst = 0;
      let cgst = 0;
      let igst = 0;
      if (gst_number && gst_number.substring(0, 2) === '24') {
        sgst = serviceTax / 2;
        cgst = serviceTax / 2;
        igst = 0;
      } else {
        sgst = 0;
        cgst = 0;
        igst = serviceTax;
      }
      fareSummaryRef.current.returnSgst = sgst;
      fareSummaryRef.current.returnCgst = cgst;
      fareSummaryRef.current.returnIgst = igst;
      const totalAmount =
        airlineTotal +
        serviceCharges +
        sgst +
        cgst +
        igst -
        commmission +
        tds +
        returntransactionFee;
      fareSummaryRef.current.returntotalamount = totalAmount;
    } else {
      fareSummaryRef.current.returnbasefare = 0;
      fareSummaryRef.current.returnairlinetaxes = 0;
      fareSummaryRef.current.returnaddons = 0;
      fareSummaryRef.current.returnairlinetotal = 0;
      fareSummaryRef.current.returnservicecharges = 0;
      fareSummaryRef.current.returnCommmission = 0;
      fareSummaryRef.current.returnTds = 0;
      fareSummaryRef.current.returnDebitCreditNote = 0;
      fareSummaryRef.current.returntransactionFee = 0;
      fareSummaryRef.current.returnkvalue = 0;
      fareSummaryRef.current.returnyqvalue = 0;
      fareSummaryRef.current.returnyrvalue = 0;
      fareSummaryRef.current.returnSgst = 0;
      fareSummaryRef.current.returnCgst = 0;
      fareSummaryRef.current.returnIgst = 0;
      fareSummaryRef.current.returntotalamount = 0;
    }
    const grandTotal =
      (fareSummaryRef.current.returntotalamount || 0) +
      (fareSummaryRef.current.onwardtotalamount || 0);
    fareSummaryRef.current.grandTotal = grandTotal;
  };

  const getData = async () => {
    setIsLoading(true);
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getFlightTicketApi(
      transactionId,
      userProfile?.agentId,
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { FlightInvoice, UserDetails } =
        response.ApiStatus.Result.FullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      agentDetailsRef.current = UserDetails.UserProfile;
      const { FlightTicket } = FlightInvoice.FlightTickets;
      flightTicketRef.current = Array.isArray(FlightTicket)
        ? FlightTicket
        : [FlightTicket];
      if (response.ApiStatus.Result.FullFlightDetails.CreditDebitNotes) {
        const { CreditDebitNote } =
          response.ApiStatus.Result.FullFlightDetails.CreditDebitNotes;
        creditDebitNoteRef.current = Array.isArray(CreditDebitNote)
          ? CreditDebitNote
          : [CreditDebitNote];
      }
      if (FlightInvoice.BarCodes) {
        barCodesRef.current = Array.isArray(FlightInvoice.BarCodes.BarCode)
          ? FlightInvoice.BarCodes.BarCode
          : [FlightInvoice.BarCodes.BarCode];
      }
      if (FlightInvoice.PassengerSSRRecords !== '') {
        const { PassengerSSRRecord } = FlightInvoice.PassengerSSRRecords;
        passengerSSRRef.current = Array.isArray(PassengerSSRRecord)
          ? PassengerSSRRecord
          : [PassengerSSRRecord];
      }
      let { SectorRecord } = flightInvoiceRef.current.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      sectorFareTypesRef.current = SectorRecord.reduce((acc, cur) => {
        if (!acc[cur]) {
          acc[`${cur.Origin} - ${cur.Destination}`] = cur.Faretype;
        }
        return acc;
      }, {});
      sectorFullNameMapRef.current = SectorRecord.reduce((acc, sector) => {
        if (acc[sector.Origin] === undefined) {
          acc[sector.Origin] =
            sector.OriginFullName === '-'
              ? sector.Origin
              : sector.OriginFullName;
        }
        if (acc[sector.Destination] === undefined) {
          acc[sector.Destination] =
            sector.DestinationFullName === '-'
              ? sector.Destination
              : sector.DestinationFullName;
        }
        return acc;
      }, {});
      flightSectorsRef.current = SectorRecord;
      onwardSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType?.toLowerCase() === 'onward',
      );
      returnSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType?.toLowerCase() === 'return',
      );
      let { PassengerRecord } = flightInvoiceRef.current.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];
      passengerRef.current = PassengerRecord;
      passengerRef.current.forEach((pax) => {
        const ft = flightTicketRef.current.find((x) => x.Paxid === pax.Paxid);
        const ssr = passengerSSRRef.current.find((x) => x.Paxid === pax.Paxid);
        if (ft) {
          pax.flightTicketNumber = ft.TicketNumber;
          pax.flightAirlinePnr = FlightInvoice.FlightRecord.AirlinePnr;
          pax.GdsPnr = FlightInvoice.FlightRecord.GdsPnr;
        }
        if (ssr) {
          if (ssr.SSRType === 'meal') {
            pax.ssrMeal = ssr.SSR;
          }
          if (ssr.SSRType === 'seat') {
            pax.ssrSeat = ssr.SSR;
          }
        }
      });
      onwardPaxRef.current = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 1,
      );
      returnPaxRef.current = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 2,
      );
      if (FlightInvoice.FlightRecord.JType.toLowerCase() === 'roundtrip') {
        setRoundtripFareSummary(response.ApiStatus.Result);
      } else {
        setFareSummary(response.ApiStatus.Result);
      }
      setHasTicket(true);
      setIsLoading(false);
    } else {
      setHasTicket(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [transactionId]);

  const getPaymentMode = (mode) => {
    if (mode === 'cashcard') {
      return 'Wallet';
    }
    return mode;
  };

  const showGdsPnr = Array.isArray(passengerRef.current)
    ? passengerRef.current.some((pax) => pax.flightAirlinePnr !== pax.GdsPnr)
    : false;

  return (
    <section className="flight-ticket-invoice-page pb-3">
      {hasTicket && (
        <section className="print-links d-flex flex-column hide-in-print">
          <a onClick={() => window.print()}>
            <img src="/images/others/print_sidebutton.png" alt="" />
          </a>
          <a href={NAVIGATION_ROUTES.LANDING}>
            <img src="/images/others/home_sidebutton.png" alt="" />
          </a>
        </section>
      )}
      <AppLoading isLoading={isLoading} />
      {hasTicket !== undefined && hasTicket && (
        <div
          style={{
            padding: '1rem 10px',
            width: '900px',
            marginInline: 'auto',
            backgroundColor: '#fff',
          }}
        >
          <div style={{ border: '1px solid #000' }}>
            <div
              style={{
                padding: '10px',
                fontWeight: '600',
                borderBottom: '1px solid #000',
              }}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="flex-1">
                {/* <img
                  src={getStringFromLS(APP_LOGO_URL)}
                  alt={appConfig?.companyName}
                  width="100px"
                /> */}
                {!imageLoadError &&
                !isNullOrEmpty(getStringFromLS(APP_AGENT_LOGO_URL)) ? (
                  <img
                    src={getStringFromLS(APP_AGENT_LOGO_URL)}
                    alt=""
                    style={{ maxHeight: `${appConfig.logoHeight}px` }}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.target.src = null;
                      setImageLoadError(true);
                    }}
                  />
                ) : (
                  <img
                    src={getStringFromLS(APP_LOGO_URL)}
                    alt=""
                    style={{ maxHeight: `${appConfig.logoHeight}px` }}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.target.src = null;
                    }}
                  />
                )}
              </div>
              <div className="flex-1 text-start">INVOICE</div>
            </div>
            <div
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                fontWeight: '300',
              }}
              className="d-flex flex-column"
            >
              {getValueFromAppConfig('INVADDRESS')
                .split('<br>')
                .map((d, index) => (
                  <span key={index}>{d}</span>
                ))}
            </div>
            {agentDetailsRef.current && (
              <div
                className="py-1 fs-12 d-flex px-2"
                style={{ border: '1px solid #000' }}
              >
                <div className="d-flex flex-column flex-1 gap-1">
                  <span>
                    <b>To M/s:</b> {agentDetailsRef.current.Company}
                    <br />
                  </span>
                  <span>
                    <b>Address: </b>
                    {agentDetailsRef.current.Address1},
                    {agentDetailsRef.current.Address2},
                    {agentDetailsRef.current.City},
                    {agentDetailsRef.current.State},
                    {agentDetailsRef.current.PinCode},
                    <br />
                  </span>
                  <span>
                    <b>Email: </b>
                    {agentDetailsRef.current.ContactEmail}
                    <br />
                  </span>
                  <span>
                    <b>Phone: </b>
                    {agentDetailsRef.current.ContactNumber}
                    <br />
                  </span>
                  <span>
                    <b>GSTN No: </b> {agentDetailsRef.current.Gst_number}
                  </span>
                  <span>
                    <b>Agent Id: </b>{' '}
                    {flightInvoiceRef.current.FlightRecord.AgentId}
                  </span>
                  {getValueFromAppConfig('SHOWADMINREMARKSINTICKET') ===
                    'true' && (
                    <span>
                      <b>Admin Remarks: </b>
                      {flightInvoiceRef.current.FlightRecord.Spare1}
                    </span>
                  )}
                </div>
                <div className="d-flex justify-content-end pe-4 flex-1">
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>Invoice Date: </b>{' '}
                      {formatDate(
                        getNewDate(
                          flightInvoiceRef.current.FlightRecord.BookingDate.split(
                            ' ',
                          )[0],
                        ),
                        DATE_MONTH_YEAR_FORMAT,
                      )}
                    </span>
                    <span>
                      <b>Invoice No: </b>{' '}
                      {flightInvoiceRef.current.FlightRecord.ErpTxid}
                    </span>
                    <span>
                      <b>HSN/SAC: </b> 998551
                    </span>
                    <span>
                      <b>Payment Mode: </b>{' '}
                      <span style={{ textTransform: 'capitalize' }}>
                        {getPaymentMode(
                          flightInvoiceRef.current.FlightRecord.PaymentMode,
                        )}
                      </span>
                    </span>
                    <span>
                      <b>Tx Id: </b>{' '}
                      <span>{flightInvoiceRef.current.FlightRecord.Txid}</span>
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="text-center p-1 fs-12 fw-500">
              Category Type : Flight
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12  w-100 ">
                <thead>
                  <tr className="text-center">
                    <th>Sector(s) & Flight Details</th>
                  </tr>
                </thead>
                <tbody>
                  {flightSectorsRef.current.map((sector) => (
                    <tr
                      key={`${sector.Origin}_${sector.Destination}_${sector.TripNumber}`}
                    >
                      <td>
                        {`${sector.Origin} - ${sector.Destination} | ${
                          AIRLINE_NAMES_FOR_CARRIER_CODE[
                            sector.Carrier.substring(0, 2)
                          ]
                        } (${sector.Carrier.substring(0, 2)} ${
                          sector.FlightNumber
                        }) |`}
                        {` Departure Time : ${formatTimeString(
                          sector.DepartureTime,
                        )},`}{' '}
                        {formatDate(
                          getNewDate(sector.JourneyDate),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12 w-100 ">
                <thead>
                  <tr>
                    <th colSpan="3" className="text-center">
                      Passenger details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="fw-bold">
                    <td>Passenger Name</td>
                    <td>Type</td>
                    <td>Ticket Number</td>
                    <td> Sector</td>
                    <td>Seat No</td>
                    <td>Airline PNR</td>
                    {showGdsPnr && <td>GDS PNR</td>}
                  </tr>
                  {flightSectorsRef.current.map((sector) => (
                    <React.Fragment
                      key={`${sector.Origin}_${sector.Destination}_${sector.FlightType}_${sector.TripNumber}`}
                    >
                      {(sector.FlightType?.toLowerCase() === 'onward'
                        ? onwardPaxRef.current
                        : returnPaxRef.current
                      ).map((pax) => {
                        const seatCodes = [];
                        const additionalInfos = [];
                        const paxSsrs = passengerSSRRef.current.filter(
                          (ssr) =>
                            ssr.Paxid === pax.Paxid &&
                            ssr.Origin === sector.Origin &&
                            ssr.Destination === sector.Destination &&
                            ssr.SSRType === 'seat',
                        );
                        paxSsrs.forEach((ssr) => {
                          if (ssr.SSRCode) seatCodes.push(ssr.SSRCode);
                          if (ssr.AdditionalInfo)
                            additionalInfos.push(ssr.AdditionalInfo);
                        });
                        const seatText =
                          seatCodes.length > 0 ? seatCodes.join(',') : '';
                        const additionalText =
                          additionalInfos.length > 0
                            ? additionalInfos.join(',')
                            : '';

                        return (
                          <tr
                            key={`${pax.Paxid}_${pax.SegmentNumber}_${sector.Origin}`}
                          >
                            <td
                              style={{ textTransform: 'uppercase' }}
                            >{`${pax.Title}.${pax.FirstName}  ${pax.LastName}`}</td>
                            <td style={{ textTransform: 'capitalize' }}>
                              {pax.Type}
                            </td>
                            <td>{pax.flightTicketNumber}</td>
                            <td>
                              {sector.Origin} - {sector.Destination}
                            </td>
                            <td>
                              {seatText}
                              <br />
                              {additionalText}
                            </td>
                            <td>{pax.flightAirlinePnr}</td>
                            {showGdsPnr && <td>{pax.GdsPnr}</td>}
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="fs-12 d-flex justify-content-between gap-1 px-2 border-bottom pb-2">
              {flightInvoiceRef.current.FlightRecord.JType.toLowerCase() ===
              'roundtrip' ? (
                <>
                  <div className="d-flex align-items-end">
                    <p className="mb-0">
                      <b>Amount in Words : </b>
                      <span className="text-capitalize fw-300">
                        <NumberToWords
                          number={fareSummaryRef.current.grandTotal?.toFixed(2)}
                        />
                      </span>
                    </p>
                  </div>
                  <div className="d-flex justify-content-end">
                    <table>
                      <tbody>
                        <tr
                          style={{
                            borderBottom: '1px solid black',
                            fontWeight: 'bold',
                          }}
                        >
                          <td>Tax Name</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            Onward
                          </td>
                          <td style={{ textAlign: 'end' }}>Return</td>
                        </tr>
                        <tr>
                          <td>[+] Basic</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardbasefare.toFixed(2)}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnbasefare.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Airline Taxes</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardairlinetaxes.toFixed(
                              2,
                            )}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnairlinetaxes.toFixed(
                              2,
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Other Charges</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardtransactionFee.toFixed(
                              2,
                            )}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returntransactionFee.toFixed(
                              2,
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] K3</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardkvalue.toFixed(2)}
                          </td>{' '}
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnkvalue.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] YQ</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardyqvalue.toFixed(2)}
                          </td>{' '}
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnyqvalue.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] YR</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardyrvalue.toFixed(2)}
                          </td>{' '}
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnyrvalue.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Addons</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardaddons.toFixed(2)}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnaddons.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Service Charge</td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardservicecharges.toFixed(
                              2,
                            )}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returnservicecharges.toFixed(
                              2,
                            )}
                          </td>
                        </tr>
                        {appConfig.isIntlClient !== 'true' && (
                          <>
                            <tr>
                              <td>[+] SGST @ 9%</td>
                              <td className="px-2">:</td>
                              <td
                                style={{
                                  textAlign: 'end',
                                  paddingRight: '10px',
                                }}
                              >
                                {fareSummaryRef.current.onwardSgst.toFixed(2)}
                              </td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.onwardSgst.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>[+] CGST @ 9%</td>
                              <td className="px-2">:</td>
                              <td
                                style={{
                                  textAlign: 'end',
                                  paddingRight: '10px',
                                }}
                              >
                                {fareSummaryRef.current.onwardCgst.toFixed(2)}
                              </td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.returnCgst.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>[+] IGST @ 18%</td>
                              <td className="px-2">:</td>
                              <td
                                style={{
                                  textAlign: 'end',
                                  paddingRight: '10px',
                                }}
                              >
                                {fareSummaryRef.current.onwardIgst.toFixed(2)}
                              </td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.returnIgst.toFixed(2)}
                              </td>
                            </tr>{' '}
                          </>
                        )}
                        {getValueFromAppConfig('DISABLE_COMMISSION_AND_TDS') !==
                          'true' && (
                          <>
                            <tr>
                              <td>[-] Commission</td>
                              <td className="px-2">:</td>
                              <td
                                style={{
                                  textAlign: 'end',
                                  paddingRight: '10px',
                                }}
                              >
                                {fareSummaryRef.current.onwardCommmission.toFixed(
                                  2,
                                )}
                              </td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.returnCommmission.toFixed(
                                  2,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>[+] TDS</td>
                              <td className="px-2">:</td>
                              <td
                                style={{
                                  textAlign: 'end',
                                  paddingRight: '10px',
                                }}
                              >
                                {fareSummaryRef.current.onwardTds.toFixed(2)}
                              </td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.returnTds.toFixed(2)}
                              </td>
                            </tr>
                          </>
                        )}
                        {creditDebitNoteRef.current.length > 0 && (
                          <tr>
                            <td>
                              {creditDebitNoteRef.current.some(
                                (note) => note.TxType === 'DEBITNOTE',
                              )
                                ? '[-] Debit Note'
                                : '[+] Credit Note'}
                            </td>
                            <td className="px-2">:</td>
                            <td
                              style={{ textAlign: 'end', paddingRight: '10px' }}
                            >
                              {fareSummaryRef.current.onwardDebitCreditNote.toFixed(
                                2,
                              )}
                            </td>
                            <td style={{ textAlign: 'end' }}>
                              {fareSummaryRef.current.returnDebitCreditNote.toFixed(
                                2,
                              )}
                            </td>
                          </tr>
                        )}
                        {appConfig.isIntlClient === 'true' && (
                          <tr>
                            <td>[+] VAT</td>
                            <td className="px-2">:</td>
                            <td
                              style={{ textAlign: 'end', paddingRight: '10px' }}
                            >
                              {fareSummaryRef.current.onwardServiceTax.toFixed(
                                2,
                              )}
                            </td>
                            <td style={{ textAlign: 'end' }}>
                              {fareSummaryRef.current.returnServiceTax.toFixed(
                                2,
                              )}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>Total Amount (Rs) </td>
                          <td className="px-2">:</td>
                          <td
                            style={{ textAlign: 'end', paddingRight: '10px' }}
                          >
                            {fareSummaryRef.current.onwardtotalamount.toFixed(
                              2,
                            )}
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.returntotalamount.toFixed(
                              2,
                            )}
                          </td>
                        </tr>
                        <tr
                          style={{
                            borderBlock: '1px solid black',
                            fontWeight: 'bold',
                          }}
                        >
                          <td>Total Billing Amount (Rs) </td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }} colSpan={2}>
                            {fareSummaryRef.current.grandTotal?.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex align-items-end">
                    <p className="mb-0">
                      <b>Amount in Words : </b>
                      <span className="text-capitalize fw-300">
                        <NumberToWords
                          number={fareSummaryRef.current.totalamount.toFixed(2)}
                        />
                      </span>
                    </p>
                  </div>
                  <div className="d-flex justify-content-end">
                    <table>
                      <tbody>
                        <tr>
                          <td>[+] Basic</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.basefare.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Airline Taxes</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.airlinetaxes.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Other Charges</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.transactionFee.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] K3</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.kvalue.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] YQ</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.yqvalue.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] YR</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.yrvalue.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Addons</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.addons.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>[+] Service Charge</td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.servicecharges.toFixed(2)}
                          </td>
                        </tr>
                        {appConfig.isIntlClient !== 'true' && (
                          <>
                            {' '}
                            <tr>
                              <td>[+] SGST @ 9%</td>
                              <td className="px-2">:</td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.Sgst.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>[+] CGST @ 9%</td>
                              <td className="px-2">:</td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.Cgst.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>[+] IGST @ 18%</td>
                              <td className="px-2">:</td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.Igst.toFixed(2)}
                              </td>
                            </tr>{' '}
                          </>
                        )}
                        {getValueFromAppConfig('DISABLE_COMMISSION_AND_TDS') !==
                          'true' && (
                          <>
                            <tr>
                              <td>[-] Commission</td>
                              <td className="px-2">:</td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.Commmission.toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>[+] TDS</td>
                              <td className="px-2">:</td>
                              <td style={{ textAlign: 'end' }}>
                                {fareSummaryRef.current.Tds.toFixed(2)}
                              </td>
                            </tr>
                          </>
                        )}
                        {appConfig.isIntlClient === 'true' && (
                          <tr>
                            <td>[+] VAT</td>
                            <td className="px-2">:</td>
                            <td style={{ textAlign: 'end' }}>
                              {fareSummaryRef.current.Servicetax.toFixed(2)}
                            </td>
                          </tr>
                        )}
                        <tr
                          style={{
                            borderBlock: '1px solid black',
                            fontWeight: 'bold',
                          }}
                        >
                          <td>Total Billing Amount (Rs) </td>
                          <td className="px-2">:</td>
                          <td style={{ textAlign: 'end' }}>
                            {fareSummaryRef.current.totalamount.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
            {(() => {
              const debitNotes = creditDebitNoteRef.current.filter(
                (note) => note.TxType === 'DEBITNOTE',
              );
              const creditNotes = creditDebitNoteRef.current.filter(
                (note) => note.TxType === 'CREDITNOTE',
              );
              const renderRows = (notes, sign) =>
                notes.map((note) => (
                  <tr key={note.Txid}>
                    <td>{note.Txid}</td>
                    <td>{note.TxDate}</td>
                    <td style={{ textAlign: 'end' }}>
                      {sign}
                      {note.Amount.toFixed(2)}
                    </td>
                    <td>{note.Remarks}</td>
                  </tr>
                ));
              return (
                <>
                  {debitNotes.length > 0 && (
                    <div className="mb-2">
                      <table className="table-bordered fs-12 w-100">
                        <thead>
                          <tr>
                            <th colSpan="4" className="text-center">
                              Debit Notes Issued Against(-)
                            </th>
                          </tr>
                          <tr className="fw-bold">
                            <td>Tx id</td>
                            <td>Tx Date</td>
                            <td>Amount</td>
                            <td>Remarks</td>
                          </tr>
                        </thead>
                        <tbody>{renderRows(debitNotes, '-')}</tbody>
                      </table>
                    </div>
                  )}
                  {creditNotes.length > 0 && (
                    <div className="mb-2">
                      <table className="table-bordered fs-12 w-100">
                        <thead>
                          <tr>
                            <th colSpan="4" className="text-center">
                              Credit Notes Issued Against(+)
                            </th>
                          </tr>
                          <tr className="fw-bold">
                            <td>Tx id</td>
                            <td>Tx Date</td>
                            <td>Amount</td>
                            <td>Remarks</td>
                          </tr>
                        </thead>
                        <tbody>{renderRows(creditNotes, '+')}</tbody>
                      </table>
                    </div>
                  )}
                </>
              );
            })()}
            <div className="p-2 fs-12 fw-600">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1 flex-column flex-1">
                  <span>
                    <b>Terms & Conditions: </b>
                  </span>
                  <ul>
                    <li>
                      This is computer generated invoice signature not required.
                    </li>
                    <li>
                      Refunds Cancellations are subject to Airlines&apos;s
                      approval
                    </li>
                    <li>
                      Kindly check all details carefully to avoid unnecessary
                      complications.
                    </li>
                    <li>
                      CHEQUE : Must be drawn in favour of &quot;
                      {getValueFromAppConfig('COMPANYNAME')} &quot;
                    </li>
                    <li>
                      LATE PAYMENT : Interest @ 24% per annum will be charged on
                      all outstanding bills after the due date.
                    </li>
                    <li>
                      All transactions between the Company and the Agency are
                      subject to the Company&apos;s Privacy Policy and Terms and
                      Conditions
                    </li>
                    <li>
                      All invoices and credit notes are confidential and should
                      not be disclosed to third parties without prior written
                      consent from the Company.
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-column justify-content-end align-items-center mb-3">
                  {!isNullOrEmpty(getValueFromAppConfig('AGENTSTAMPURL')) && (
                    <img
                      src={getValueFromAppConfig('AGENTSTAMPURL')}
                      alt="Stamp"
                      style={{
                        width: '170px',
                        height: 'auto',
                        marginBottom: '10px',
                        zIndex: 1,
                      }}
                    />
                  )}
                  <p>{getValueFromAppConfig('COMPANYNAME')}</p>
                  <span>Authorised Signature</span>
                </div>
              </div>
              {/* <div
                style={{
                  marginTop: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                {getValueFromAppConfig('bankdetailshtml')}
              </div> */}

              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '15px',
                  marginTop: '20px',
                }}
              >
                {bankDetails.length === 0 ? (
                  <div
                    style={{
                      textAlign: 'center',
                      padding: '12px',
                      color: '#999',
                      fontSize: '14px',
                      border: '1px dashed #ddd',
                      borderRadius: '6px',
                      width: '100%',
                    }}
                  >
                    No bank details available
                  </div>
                ) : (
                  bankDetails.map((bank, index) => (
                    <div
                      key={index}
                      style={{
                        border: '1px solid #e5e7eb',
                        borderRadius: '10px',
                        padding: '15px',
                        background: '#ffffff',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                        width: 'calc(50% - 10px)',
                      }}
                    >
                      {/* Header */}
                      <div
                        style={{
                          fontWeight: '600',
                          fontSize: '16px',
                          marginBottom: '10px',
                          color: '#1f2937',
                        }}
                      >
                        {bank.bankName}
                      </div>
                      <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
                        <div>
                          <strong>Company:</strong> {bank.companyName}
                        </div>
                        <div>
                          <strong>Branch:</strong> {bank.branch}
                        </div>
                        <div>
                          <strong>IFSC:</strong> {bank.ifsc}
                        </div>
                        <div>
                          <strong>Account No:</strong> {bank.accountNumber}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {hasTicket !== undefined && hasTicket === false && (
        <section className="flight-ticket-invoice_container">
          No Invoice found with {transactionId}
        </section>
      )}
      {/* <section className="hide-in-print flight-ticket-page__container pb-5 pt-3 d-flex justify-content-center">
        {flightInvoiceRef.current &&
          flightInvoiceRef.current.FlightRecord.BookingStatus !==
            'released' && (
            <AppButton btnText="Print" onClick={() => window.print()} />
          )}
        <AppButton
          variant="secondary"
          btnText="Home"
          className="ms-3"
          onClick={() => navigate('/')}
        />
      </section> */}
    </section>
  );
}

export default FlightTicketInvoicePage;
